import React from 'react'
import FormBasicInformation from './FormBasicInformation'
import FormCurriculum from './FormCurriculum'
import FormLevels from './FormLevels'
import FormRatingType from './FormRatingType'

const FormAssessment = ({ form = {}, errors = {}, onChange, type, curriculumList }) => {
  return (
    <>
      <div className='grid grid-cols-4 items-center gap-4'>
        <FormBasicInformation form={form} errors={errors} onChange={onChange} type={type} />
        <FormRatingType form={form} errors={errors} onChange={onChange} type={type} />
        <FormCurriculum
          form={form}
          errors={errors}
          onChange={onChange}
          type={type}
          curriculumList={curriculumList}
        />
      </div>
      <FormLevels
        form={form}
        errors={errors}
        onChange={onChange}
        type={type}
        curriculumId={form.curriculumId}
        curriculumName={form.curriculumName}
        curriculumList={curriculumList}
      />
    </>
  )
}

export default FormAssessment
